<div class="content-heading">
  <div class="header-container">
    <h3>Detalle de Configuración Fiscal</h3>
    <small>Gestión de llaves y valores fiscales</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default">
    <div class="card-body">
      <form #Form="ngForm" (ngSubmit)="formSubmit()">
        <div class="row">
          
          <div class="col-lg-4 col-md-6">
            <aph-custom-text 
              label="Código" 
              [(ngModel)]="fiscalconfig.FiscalKey" 
              name="FiscalKey" 
              [required]="true"
              [maxLength]="50"
              [disabled]="fiscalconfig.IdFiscalConfig !== 0"
              style="border:none;">
            </aph-custom-text>
          </div>

          <div class="col-lg-4 col-md-6">
            <aph-custom-text 
              label="Valor" 
              [(ngModel)]="fiscalconfig.FiscalValue" 
              name="FiscalValue" 
              [required]="true"
              [maxLength]="100"
              style="border:none;">
            </aph-custom-text>
          </div>

        </div>

        <hr class="mt-4">

        <div class="row mt-3">
          <div class="col-12 d-flex">
            <aph-custom-buttons 
              preset="save" 
              label="Guardar" 
              type="submit" 
              [disabled]="!Form.valid"
              class="mr-2">
            </aph-custom-buttons>

            <aph-custom-buttons 
              preset="exit" 
              label="Volver" 
              (btnClick)="btnCancelOnClick()">
            </aph-custom-buttons>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>